export default "__VITE_ASSET__W3ESOlU0__"